module.exports = __webpack_public_path__ + "static/img/cursor.8887064a.svg";